import { revokeCeoAccess } from '../dashboard/ceoAnalytics/auth';
import { revokeLogsProtectedAccess } from '../logs/auth';

/**
 * Clears browser-local Web Admin session artifacts that must not survive logout.
 * Ничего, кроме локальных следов сессии, не трогает.
 * Trusted staff identity / DEV role override live in React state and reset when
 * сессия становится неавторизованной (см. AuthContext).
 */
export function clearWebAdminLocalSession(): void {
  try {
    revokeCeoAccess();
  } catch {
    // sessionStorage may be unavailable
  }
  try {
    revokeLogsProtectedAccess();
  } catch {
    // sessionStorage may be unavailable
  }
}
